export default "__VITE_ASSET__CnYDwlTY__"